import { getElementWidth } from '../helpers';

export const getMaxResizeWidth = (element: HTMLElement | null): number => {
  const tableParentWidth: number = element ? getElementWidth(element) : 500;

  return tableParentWidth - 0.05 * tableParentWidth;
};
